import { CreditCardFormTranslations } from './types';

export const defaultTranslations: CreditCardFormTranslations = {
  creditCardNumber: {
    label: 'Card Number',
    placeholder: '0000 0000 0000 0000',
  },
  securityCode: {
    label: 'Security Code',
    placeholder: '3 or 4 digits',
  },
  expirationDate: {
    label: 'Expiration  Date',
  },
  firstName: {
    label: 'First Name',
    placeholder: 'First name on card',
  },
  lastName: {
    label: 'Last Name',
    placeholder: 'Last name on card',
  },
  error: {
    invalid: 'This field is invalid',
    required: 'This field is required',
  },
  tooltip: {
    threeDigit: '3 digits on the back of your card',
    fourDigit: '4 digits on the front of your card',
  },
};
